import { SyntheticEvent } from 'react';
import { Snackbar } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import { SxProps, Theme } from '@mui/system';

import { CoreBox } from '@youscience/core';

import { StyledAlert } from './CoreSnackbar.styles';

type Severity = 'success' | 'error' | 'info' | 'warning';

export interface CoreSnackbarProps {
  actionHandler?: () => void;
  actionText?: string;
  autoHideDuration?: number;
  className?: string;
  expanded?: boolean;
  horizontal?: 'left' | 'center' | 'right';
  message: string;
  title?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClose?: (event: SyntheticEvent<any> | Event, reason: string) => void;
  open?: boolean;
  severity?: Severity;
  sx?: SxProps<Theme>;
  TransitionProps?: TransitionProps;
  vertical?: 'top' | 'bottom';
}

export const CoreSnackbar = ({
  actionHandler,
  actionText,
  autoHideDuration,
  className,
  expanded = false,
  horizontal = 'right',
  message,
  title,
  severity = 'info',
  sx,
  vertical = 'bottom',
  ...rest
}: CoreSnackbarProps) => (
  <Snackbar {...{ autoHideDuration, className, sx }} anchorOrigin={{ vertical, horizontal }} {...rest}>
    <CoreBox>
      <StyledAlert
        {...(actionText ? { actionText, actionHandler } : {})}
        description={message}
        title={title}
        expanded={expanded}
        severity={severity}
        showCloseIcon={!expanded}
        variant="filled"
      />
    </CoreBox>
  </Snackbar>
);
